import ellipsize from "ellipsize";
import latinize from "latinize";
import { extend } from "lodash-es";
import { stripHtml } from "string-strip-html";
// modify the behavior for German umlauts
// noinspection NonAsciiCharacters
extend(latinize.characters, {
    Ä: "Ae",
    Ö: "Oe",
    Ü: "Ue",
    ä: "ae",
    ö: "oe",
    ü: "ue",
});
export const stripHtmlTags = (html = "", keepLineBreaks = true) => {
    return stripHtml(keepLineBreaks
        ? html
            .replace(/<br ?\/?>/gi, `<br/>\n`)
            .replace(/<\/(br|p|li|h1|h2|h3|h4|h5|h6)>/gi, `</$1>\n`)
        : html).result;
};
export const nl2br = (text) => text.replace(/\r\n|\r|\n/g, "<br/>");
export const truncateText = (text, maxSymbolsAmount) => ellipsize(text, maxSymbolsAmount);
export function getFileName(name, spacer = "-") {
    return latinize(name)
        .replace(/[^0-9a-zA-Z ]/gi, "")
        .replace(/\s+/gi, spacer);
}
//# sourceMappingURL=text.js.map